<template>
  <div class="join-form">
    <div class="join-form--left">
      <div class="join-form--left--benefits">
        <div class="join-form--left--top">
          <h2>Membership benefits</h2>
          <p>
            Membership of the Australian Medical Association gives you access to
            a comprehensive range of professional and workplace relations
            services.
          </p>
        </div>
        <div class="join-form--left--list">
          <ul>
            <li>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-percent"><line x1="19" x2="5" y1="5" y2="19"/><circle cx="6.5" cy="6.5" r="2.5"/><circle cx="17.5" cy="17.5" r="2.5"/></svg>
              </span>
              <span class="text">
                <strong>Medical indemnity</strong><br />Members receive
                discounted rates for insurance.
              </span>
            </li>
            <li>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-badge-check"><path d="M3.85 8.62a4 4 0 0 1 4.78-4.77 4 4 0 0 1 6.74 0 4 4 0 0 1 4.78 4.78 4 4 0 0 1 0 6.74 4 4 0 0 1-4.77 4.78 4 4 0 0 1-6.75 0 4 4 0 0 1-4.78-4.77 4 4 0 0 1 0-6.76Z"/><path d="m9 12 2 2 4-4"/></svg>
              </span>
              <span class="text">
                <strong>Accredited training</strong><br />Discounted accredited
                training and development workshops.
              </span>
            </li>
            <li>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-user-round-check"><path d="M2 21a8 8 0 0 1 13.292-6"/><circle cx="10" cy="8" r="5"/><path d="m16 19 2 2 4-4"/></svg>
              </span>
              <span class="text">
                <strong>Professional services</strong><br />Access to discounted
                solicitor and accounting services.
              </span>
            </li>
            <li>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-heart-handshake"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/><path d="M12 5 9.04 7.96a2.17 2.17 0 0 0 0 3.08v0c.82.82 2.13.85 3 .07l2.07-1.9a2.82 2.82 0 0 1 3.79 0l2.96 2.66"/><path d="m18 15-2-2"/><path d="m15 18-2-2"/></svg>
              </span>
              <span class="text">
                <strong>Wellbeing support services</strong><br />Free and
                confidential 24/7 counselling and peer support.
              </span>
            </li>
            <li>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shopping-basket"><path d="m15 11-1 9"/><path d="m19 11-4-7"/><path d="M2 11h20"/><path d="m3.5 11 1.6 7.4a2 2 0 0 0 2 1.6h9.8a2 2 0 0 0 2-1.6l1.7-7.4"/><path d="M4.5 15.5h15"/><path d="m5 11 4-7"/><path d="m9 11 1 9"/></svg>
              </span>
              <span class="text">
                <strong>Medical products and instruments</strong><br />Members
                receive discounted rates for medical products.
              </span>
            </li>
            <li>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-book-open-text"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/><path d="M6 8h2"/><path d="M6 12h2"/><path d="M16 8h2"/><path d="M16 12h2"/></svg>
              </span>
              <span class="text">
                <strong>Magazines and newsletters</strong><br />Accurate, timely
                and relevant information affecting your career.
              </span>
            </li>
            <li>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-blocks"><rect width="7" height="7" x="14" y="3" rx="1"/><path d="M10 21V8a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1H3"/></svg>
              </span>
              <span class="text">
                <strong>CPD tracking and learning</strong><br />Self-manage your
                continuous professional development.
              </span>
            </li>
            <li>
              <span class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-ticket-x"><path d="M2 9a3 3 0 0 1 0 6v2a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-2a3 3 0 0 1 0-6V7a2 2 0 0 0-2-2H4a2 2 0 0 0-2 2Z"/><path d="m9.5 14.5 5-5"/><path d="m9.5 9.5 5 5"/></svg>
              </span>
              <span class="text">
                <strong>Tax deductible</strong><br />Claim a tax refund for the
                cost of your membership.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="join-form--right">
      <div class="join-form--step step-four">
        <div class="step-legend">
          <h2>Membership details</h2>
          <step-circles step="2" />
        </div>
        <div class="step-intro">
          Fill out your membership details so that we can get to know you
          better.
        </div>
        <form
          @submit.prevent="next()"
          @keypress.enter.prevent
          class="nice-form"
          @input="markDirty"
        >
          <div class="step-form">
            <div class="row">
              <label class="top-label" :class="{ filled: dobSelected }"
                >Date of birth</label
              >
              <div class="col-md-4">
                <custom-field
                  label="Day"
                  type="select"
                  :rules="{
                    required: {},
                  }"
                  v-model="data.day"
                >
                  <template v-slot:options>
                    <option value="" disabled></option>
                    <option v-for="i in 31" :key="`day-${i}`">{{ i }}</option>
                  </template>
                </custom-field>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <custom-field
                    label="Month"
                    type="select"
                    :rules="{
                      required: {},
                    }"
                    v-model="data.month"
                  >
                    <template v-slot:options>
                      <option value="" disabled></option>
                      <option value="01">January</option>
                      <option value="02">February</option>
                      <option value="03">March</option>
                      <option value="04">April</option>
                      <option value="05">May</option>
                      <option value="06">June</option>
                      <option value="07">July</option>
                      <option value="08">August</option>
                      <option value="09">September</option>
                      <option value="10">October</option>
                      <option value="11">November</option>
                      <option value="12">December</option>
                    </template>
                  </custom-field>
                </div>
              </div>
              <div class="col-md-4">
                <custom-field
                  label="Year"
                  type="select"
                  :rules="{
                    required: {},
                  }"
                  v-model="data.year"
                >
                  <template v-slot:options>
                    <option value="" disabled></option>
                    <option v-for="i in 72" :key="`year-${i}`">
                      {{ lastYear - i }}
                    </option>
                  </template>
                </custom-field>
              </div>
            </div>
            <custom-field
              label="Gender"
              type="select"
              :rules="{
                required: {},
              }"
              v-model="data.gender"
            >
              <template v-slot:options>
                <option value="" disabled>Select</option>
                <option value="M">Male</option>
                <option value="F">Female</option>
                <option value="X">Non-binary</option>
                <option value="I">Intersex</option>
                <option value="Z">I prefer not to say</option>
              </template>
            </custom-field>
            <custom-field
              label="Mobile number"
              type="tel"
              maxlength="25"
              :rules="{
                required: { message: 'Please add your mobile.' },
                regexr: {
                  pattern: /^04\d{8}$/,
                  message: 'The mobile number is invalid',
                },
              }"
              v-model="data.phone"
            />
            <div v-show="showGoogle">
              <custom-field
                label="Residential address - Start typing to search"
                type="address"
                :display-errors="false"
                @placechanged="getAddressData"
                :rules="showGoogle ? { address: {} } : {}"
                :addressInfo="data.address.address_1"
                v-model="data.addressString"
              />
              <div class="form-change-address">
                Can't find you address?
                <a href="#" @click.prevent="changeAddressManual"
                  >Enter it manually.</a
                >
              </div>
            </div>
            <div v-show="!showGoogle">
              <custom-field
                maxlength="40"
                label="Address"
                ref="manualAddress"
                :rules="!showGoogle ? { required: {} } : {}"
                v-model="data.address.address_1"
              />
              <custom-field
                maxlength="40"
                label="City"
                :rules="!showGoogle ? { required: {} } : {}"
                v-model="data.address.address_2"
              />
              <custom-field
                maxlength="40"
                label="State"
                :rules="!showGoogle ? { required: {} } : {}"
                v-model="data.address.state"
              />
              <custom-field
                maxlength="40"
                label="Zip"
                :rules="!showGoogle ? { required: {} } : {}"
                v-model="data.address.postcode"
              />
            </div>
            <custom-field
              v-if="!hideEmployment && data.stage != 'student'"
              label="Concession rates"
              type="select"
              :rules="{ required: {} }"
              v-model="data.employment"
            >
              <template v-slot:options>
                <option value=""></option>
                <option v-for="(e, k) in employment" :value="k" :key="`e-${k}`">
                  {{ e.label }}
                </option>
              </template>
            </custom-field>

            <div 
              v-if="data.state == 'SA' && data.employment == 'fullTime'"
              class="form-group ama-partner-rate"
            >
              <input
                type="checkbox"
                class="d-none"
                id="partner-rate"
                :checked="Boolean(data.partner_rate)"
                @change="togglePartnerRate"
              />
              <label for="partner-rate">
                <span v-if="data.partner_rate">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path
                      fill="currentColor"
                      d="M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z"
                    ></path>
                  </svg>
                </span>
                <span v-else>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path
                      fill="currentColor"
                      d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z"
                    ></path>
                  </svg>
                </span>
                <strong
                  >Do you have a partner who is also a member of the
                  AMA?</strong
                >
              </label>
            </div>

            <div 
              v-if="data.state == 'NSW'"
              class="form-group ama-partner-rate"
            >
              <input
                type="checkbox"
                class="d-none"
                id="partner-rate"
                :checked="Boolean(data.partner_rate)"
                @change="togglePartnerRate"
              />
              <label for="partner-rate">
                <span v-if="data.partner_rate">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path
                      fill="currentColor"
                      d="M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z"
                    ></path>
                  </svg>
                </span>
                <span v-else>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
                    <path
                      fill="currentColor"
                      d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z"
                    ></path>
                  </svg>
                </span>
                <strong
                  >Do you have a partner who is also a member of the
                  AMA?</strong
                >
              </label>
              
              <custom-field
                v-if="data.partner_rate"
                maxlength="30"
                label="Partner name"
                :rules="{ required: {} }"
                v-model="data.paterner_ama"
                style="margin-top: 15px;"
              /> 

              <input type="checkbox" class="d-none" id="ama-member" v-model="data.ama_member" value="1" />
              <label for="ama-member">
                <span v-if="data.ama_member">
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" ><path fill="currentColor" d="M400 480H48c-26.51 0-48-21.49-48-48V80c0-26.51 21.49-48 48-48h352c26.51 0 48 21.49 48 48v352c0 26.51-21.49 48-48 48zm-204.686-98.059l184-184c6.248-6.248 6.248-16.379 0-22.627l-22.627-22.627c-6.248-6.248-16.379-6.249-22.628 0L184 302.745l-70.059-70.059c-6.248-6.248-16.379-6.248-22.628 0l-22.627 22.627c-6.248 6.248-6.248 16.379 0 22.627l104 104c6.249 6.25 16.379 6.25 22.628.001z"></path></svg>
                </span>
                <span v-else>
                  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" ><path fill="currentColor" d="M400 32H48C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V80c0-26.5-21.5-48-48-48zm-6 400H54c-3.3 0-6-2.7-6-6V86c0-3.3 2.7-6 6-6h340c3.3 0 6 2.7 6 6v340c0 3.3-2.7 6-6 6z"></path></svg>
                </span>
                <strong>Were you referred by an existing AMA member?</strong>
              </label>
              
              <custom-field
                v-if="data.ama_member"
                maxlength="30"
                label="Member name"
                :rules="{ required: {} }"
                v-model="data.ama_referee"
                style="margin-top: 15px;"
              /> 
            </div>
            
            <custom-field
              label="Primary reason for joining"
              type="select"
              :rules="{}"
              v-model="data.reason"
            >
              <template v-slot:options>
                <option v-for="s, k in options.reasonJoin" :value="k" :key="`r-${k}`"> {{ s }} </option>
              </template>
            </custom-field>
          </div>
          <div class="step-footer">
            <button
              type="button"
              @click.prevent="$emit('update:step', 2)"
              class="button button-outline-blue button-nm"
            >
              Back
            </button>
            <button
              type="submit"
              class="button button-blue button-nm"
              :disabled="invalid.address"
            >
              Next
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
  import stepCircles from "../stepCircles"
  import customField from "../forms/customField"
  export default {
    name: "step-three",
    props: ["step", "form", "options"],
    components: {
      stepCircles,
      customField,
    },
    data() {
      return {
        data: {
          address: {
            address_1: "",
            address_2: "",
            state: "",
            postcode: "",
            visible: false,
          },
        },
        showGoogle: true,
        dateInputFocus: false,
        lastYear: new Date().getFullYear() - 15,
        invalid: {
          address: false,
        },
        formIsDirty: false,
      }
    },
    computed: {
      dobSelected() {
        if (this.data.day && this.data.month && this.data.year) {
          return true
        }

        return this.dateInputFocus
      },
      employment() {      
        const { stage, state } = this.data;
        if(this.data.promoteCode == 'AMANSW25') {
          console.log("NSW promotion code applied - employment");
          return this.options.memberships['NSWP'][stage]['arrangement'];
        } 

        if (stage && stage != 'student') {
          return this.options.memberships[state][stage]['arrangement'];
        }

        return []
      },
      hideEmployment() {
        return Object.keys(this.employment).length == 1
      },
      memberships() {
        const { stage, employment, state} = this.data;
        if(this.data.promoteCode == 'AMANSW25') {
          console.log("NSW promotion code applied - memberships");
          const memberships = this.options.memberships['NSWP'];
          return memberships[stage]['arrangement'][employment]['options'];
        }
        if (stage && stage != 'student' && employment) {
          const memberships = this.options.memberships[state];
          return memberships[stage]['arrangement'][employment]['options'];
        }

        return []
      },
    },
    methods: {
      changeAddressManual() {
        this.invalid.address = false
        this.showGoogle = false
      },
      markDirty() {
        this.formIsDirty = true;
      },
      togglePartnerRate(event) {
        const checked = event.target.checked;
        const value = checked ? 1 : 0;
        const nextForm = {
          ...this.form,
          partner_rate: value,
        };

        this.$set(this.data, 'partner_rate', value);
        this.$emit('update:form', nextForm);
      },
      getAddressData(fields) {
        var address = {
          address_1: "",
          address_2: "",
          address_3: "",
          city: "",
          state: "",
          postcode: "",
        }

        if (fields.street_number && fields.route) {
          address.address_1 = fields.street_number + " " + fields.route
        } else if (fields.route) {
          address.address_1 = fields.route
        }

        if (fields.locality) {
          address.address_2 = fields.locality
        }

        if (fields.administrative_area_level_2) {
          address.city = fields.administrative_area_level_2
        }

        if (fields.administrative_area_level_1) {
          address.state = fields.administrative_area_level_1
        }

        if (fields.postal_code) {
          address.postcode = fields.postal_code
        }
        
        this.data.address = address;
        this.data.addressString =  this.$options.filters.addressDisplay(address);
        
        this.invalid.address = false;
      },
      next() {
        let failed = false
        for (var i in this.$children) {
          const child = this.$children[i]
          if (child.onFocus) {
            const errors = child.onBlur()
            if (errors.length) {
              failed = true
            }
          }
        }

        if (failed) return

        if (!this.showGoogle) {
          this.data.addressString = this.$options.filters.addressDisplay(
            this.data.address
          )
        }

        if (this.memberships.length == 1) {
          this.data.membership = this.memberships[0]["key"]
        }

        if (this.data.employment != 'fullTime') {
          this.data.partner_rate = 0;
        }

        if(this.formIsDirty) {
          this.data['step'] = 3;
          window.apiTrack.post('', this.data).then(response => {
            if(response.data.success) {
              this.data.imis_id =  response.data.imis;
            }
          });
        }

        this.$emit('update:form', this.data);
        this.$emit('update:step', 4);
      }
    },
    mounted() {
      this.data = this.form
      if (this.hideEmployment) {
        this.$set(this.data, "employment", Object.keys(this.employment)[0])
      }
      if (!this.data.addressString) {
        this.invalid.address = true
      }
    },
  }
</script>
